import { cn } from "@/lib/utils";

interface PresenceCompareProps {
  hero: number;
  competitorAvg: number;
}

export function PresenceCompare({ hero, competitorAvg }: PresenceCompareProps) {
  const isAhead = hero > competitorAvg;
  const isBehind = hero < competitorAvg;

  return (
    <div className="flex items-baseline gap-1">
      <span
        className={cn(
          "text-sm",
          isAhead && "text-[hsl(var(--trend-positive))]",
          isBehind && "text-destructive",
          !isAhead && !isBehind && "text-foreground"
        )}
      >
        {hero}
      </span>
      <span className="text-xs text-muted-foreground">vs.</span>
      <span className="text-xs text-muted-foreground">{competitorAvg}</span>
    </div>
  );
}
